export enum PublicIncidentReportStatuses {
  New = 0,
  On_Hold = 1,
  Linked = 2,
  Closed = 3
}
